import React, { Component } from "react";
import { connect } from "react-redux";
import { Form as Formm } from "react-form";
import { withRouter } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MaterialTable, { MTableToolbar, MTableAction } from "material-table";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Checkbox from "@material-ui/core/Checkbox";
import Close from "@material-ui/icons/Close";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import drag from "../common/icons/dnd.png";
import CloudDownload from "@material-ui/icons/CloudDownload";
import { getCSRFToken } from '../common/Csrf'
import Subquestion from "../common/Subquestion";
import HelpLabel from "../common/HelpLabel";
import ReactSelect from "../common/ReactSelect";
import AppContainer from "../common/AppContainer";
import Select from "../common/Select";
import TextField from "../common/TextField";
import Switch from "../common/Switch";
import ColorPicker from "../common/ColorPicker";
import ParentWarningDialog from "./ParentWarningDialog";
import WarningDialog from "../common/WarningDialog";
import { createSelector } from "../common/orm";
import { ICON_LIST, MAKE_OPTIONS_ICON } from "../common/icons";
import { Page, Section, Form, SectionMapGrouping, GroupingValue, Field } from "../page/models";
import { MAKE_OPTIONS } from "../../api/constants";
import { withStyles, Tabs, Tab, Paper } from "@material-ui/core";
import ListIcon from "@material-ui/icons/ViewColumn";
import TimelineIcon from "@material-ui/icons/Timeline";
import MapIcon from "@material-ui/icons/Map";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import BlockIcon from '@material-ui/icons/Block';
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Box from "@material-ui/core/Box";

// Get all form objects and order by name
const allForms = createSelector((schema) => {
    return schema.Form.all().orderBy("name").toRefArray();
});
// Get the specific page object
// Ex: the URL is http://localhost:3000/#/page/49 we would get page object #49
const getPage = Page.selectByUrlId();
// Get all sections that are present for the current page
const getSections = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, pageId) => {
        return session.Section.filter((sect) => sect.page === pageId)
            .orderBy("order")
            .toModelArray()
            .map((section) => ({
                _forms: section.forms
                    .all()
                    .orderBy("id")
                    .toModelArray()
                    .map((form) => ({
                        groups: form.groups
                            .all()
                            .orderBy("order")
                            .toModelArray()
                            .map((group) => ({
                                fields: group.fields.all().orderBy("order").toRefArray(),
                                ...group.ref,
                            })),
                        ...form.ref,
                    })),
                _groupings: section.groupings.all().orderBy("id").toRefArray(),
                ...section.ref,
            }));
    }
);

const allPages = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (schema, pageId) => {
        const sections = schema.Section.filter(p => p.has_geometry && p.page !== pageId).orderBy("id").toModelArray();
        var pages = []
        sections.forEach(s => {
            if (!pages.some(p => p.id === s.page.id))
                pages.push(s.page)
        })
        pages.unshift({
            id: "All Modules",
            name: "All Modules"
        })
        return pages;
    }
);
const getGroupings = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, pageId) => {
        return session.SectionMapGrouping.all().orderBy("id").toRefArray();
    }
);
const getValueGroupings = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, pageId) => {
        return session.GroupingValue.all().orderBy("id").toRefArray();
    }
);

// CSS in JS
const styles = (theme) => ({
    materialTableToolbar: {
        "& > div": {
            padding: 0,
            marginLeft: -45,
        },
        "& > div div": {
            width: "100%",
        },
    },
    materialTableActions: {
        "& button": {
            width: "100%",
        },
        "& > button:hover": {
            backgroundColor: "rgba(0, 0, 0, 0)",
        },
    },
    italics: {
        fontStyle: "italic",
    },
    table: {
        minWidth: 500,
    },
    dialogMin: {
        minWidth: 400,
    },
    flex: {
        flex: 1,
    },
    button: {
        float: "right",
    },
    minWidth: {
        minWidth: 800,
    },
    gutterBottom: {
        marginBottom: ".6em",
    },
    root: {
        width: "100%",
        overflowX: "auto",
    },
    deleteWidth: {
        minWidth: 34,
        width: 34,
        margin: "0 8px 0 0",
    },
    centerAlign: {
        textAlign: "center",
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
    materialtable: {
        fontSize: "large",
    },
    buttonMargin: {
        margin: 4,
    },
    iconPush: {
        "& svg": {
            marginBottom: -8,
        },
    },
    tabRoot: {
        minHeight: 64,
        color: "#4b8dc4",
    },
    tabSelected: {
        // color: "#74A94C !important",
        color: "#4b8dc4 !important",
    },
    iconSelected: {
        color: "#74A94C !important",
    },
    stickyTabStyles: {
        backgroundColor: "#F2F0EF",
        zIndex: 1,
    },
    tabsIndicator: {
        backgroundColor: "#4b8dc4",
    },
    dialogContent: {
        padding: 0,
    },
    dialogContentText: {
        margin: 0,
        overflow: "auto",
    },
    tabPanel: {
        overflowY: "auto",
        maxHeight: "600px",
        minHeight: "600px",
        padding: 16,
        paddingBottom: "5px",
    },
});

//fields styling section for groups
const getItemStyle2 = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 1,
    margin: `6px 14px 6px 14px`,
    color: "primary",
    fontSize: "18px",
    borderRadius: 5,
    textAlign: "left",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 2px, rgba(0, 0, 0, 0.25) 0px 2px 2px",

    // change background of fields when dragging
    background: isDragging ? "lightgrey" : "lightgrey",

    // styles we need to apply on draggables
    ...draggableStyle,
});

// background color on "fields child card" section when dragging
const getListStyle2 = (isDraggingOver) => ({
    background: isDraggingOver ? "#4e4e4e" : "",
    borderRadius: 5,
    marginBottom: isDraggingOver ? 80 : 30,
});

function MAKE_OPTIONS_CUST(table) {
    return table.map((row) => ({
        label: row,
        value: row,
    }));
}

// The table in the page details component, shows all page sections
// http://localhost:3000/#/page/49
class SectionTable extends Component {
    constructor(props, context) {
        super(props, context);

        // Set the default states of the component
        this.state = {
            openEditDialog: false,
            editDialog: null,
            deleteDialogOpen: false,
            deleteDialogText: null,
            deleteDialogConfirmAction: null,
            title: true,
            newFormDialogOpen: false,
            clickedOnSection: "",
            showGeoColor: false,
            geoPoint: false,
            displayModule: false,
            geoHitFlag: true,
            showAttachmentTypes: false,
            showChartTypes: false,
            showAutoSectionCreate: false,
            showAGOLQuestions: false,
            attachmentHitFlag: true,
            chartHitFlag: true,
            contactHitFlag: true,
            autoSectionHitFlag: true,
            displayModuleHitFlag: true,
            AGOLHitFlag: true,
            moving: false
        };
        this.returnEditDialog = this.returnEditDialog.bind(this);
    }

    returnNewFormDialog = () => {
        this.setState({ newFormDialogOpen: false });
    };

    openNewFormDialog = (sectionId) => {
        const { ormSectionLoadDetailChild } = this.props;

        if (ormSectionLoadDetailChild) ormSectionLoadDetailChild(parseInt(sectionId, 10));

        this.setState({
            clickedOnSection: sectionId,
            newFormDialogOpen: true,
        });
    };

    returnEditDialog() {
        this.setState({
            openEditDialog: false,
            showGeoColor: false,
            geoPoint: false,
            displayModule: false,
            geoHitFlag: true,
            attachmentHitFlag: true,
            chartHitFlag: true,
            contactHitFlag: true,
            autoSectionHitFlag: true,
            displayModuleHitFlag: true,
            AGOLHitFlag: true,
            showAttachmentTypes: false,
            showChartTypes: false,
            showAutoSectionCreate: false,
            showAGOLQuestions: false,
            disabledRepeatable: false
        });
    }

    handleMasterContacts = (e) => {
        if (e) {
            this.setState({
                disabledRepeatable: true,
                contactHitFlag: false,
                showAttachmentTypes: false,
                attachmentHitFlag: true,
                showGeoColor: false,
                geoHitFlag: true,
                showAGOLQuestions: false,
                AGOLHitFlag: true,
                displayModule: false,
                displayModuleHitFlag: true,
            });
        } else {
            this.setState({ disabledRepeatable: false });
        }
    };


    handleGeoColor = (e) => {
        if (e) {
            this.setState({ showGeoColor: true, geoHitFlag: false });

            const v = this.formApi?.values;
            if (v && !v.geo_color) {
                this.formApi.setValue("geo_color", "#e53935");
            }
        } else {
            this.setState({ showGeoColor: false });
        }
    };

    handleGeoType = (e) => {
        if (e === "Point" || e === "MultiPoint") this.setState({ geoPoint: true });
        else this.setState({ geoPoint: false });
    };

    handleDisplayModule = (e) => {
        if (e) this.setState({ displayModule: true, displayModuleHitFlag: false });
        if (!e) this.setState({ displayModule: false });
    };

    handleAttachmentTypes = (e) => {
        if (e) this.setState({ showAttachmentTypes: true, attachmentHitFlag: false });
        if (!e) this.setState({ showAttachmentTypes: false });
    };

    handleChart = (e) => {
        if (e) this.setState({ showChartTypes: true, chartHitFlag: false });
        if (!e) this.setState({ showChartTypes: false });
    };

    handleAutoSection = (e) => {
        if (e) this.setState({ showAutoSectionCreate: true, autoSectionHitFlag: false });
        if (!e) this.setState({ showAutoSectionCreate: false });
    };

    handleAGOLQuestions = (e) => {
        if (e) this.setState({ showAGOLQuestions: true, AGOLHitFlag: false });
        if (!e) this.setState({ showAGOLQuestions: false });
    };

    // When the delete button is pressed--check for parent/child relationships. If there is a child do not allow
    // parent to be deleted.
    deleteSection = (section, name, parent) => {
        const { sections } = this.props;
        // Set the state which controls the popup dialog
        // If deleteDialogOpen = true then the popup will appear during the render event
        if (!parent) {
            this.setState({
                deleteDialogOpen: true,
                deleteDialogConfirmAction: section,
                deleteDialogText:
                    "WARNING: This will remove section for all current records. Are you sure you wish to permanently delete " + name + "?",
                buttons: false,
            });
        } else {
            let childCounter = 0;
            //add up the total children
            sections.forEach((n) => {
                if (n.parent === false) {
                    return (childCounter = childCounter + 1);
                }
            });
            //dont allow deletion as there is children
            if (childCounter > 0) {
                this.setState({
                    deleteDialogOpen: true,
                    deleteDialogConfirmAction: null,
                    deleteDialogText:
                        "WARNING: This section can not be deleted as it is the primary section and has related sections. Delete the 'non-primary' sections first.",
                    title: false,
                    buttons: true,
                });
                //no children so allow last section which is parent to be deleted
            } else if (childCounter === 0) {
                this.setState({
                    deleteDialogOpen: true,
                    deleteDialogConfirmAction: section,
                    deleteDialogText:
                        "WARNING: This will remove section for all current records. Are you sure you wish to permanently delete " + name + "?",
                    buttons: false,
                });
            }
        }
    };
    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        console.log(result);

        const { ormSectionLoadDetailChild, page, authState } = this.props;
        this.setState({ moving: true })

        // Order Sections
        if (result.destination.droppableId === "section_list") {
            var _this = this;
            //eslint-disable-next-line
            const res = fetch(`dndreorder/${page}/${result.destination.index}/${result.source.index}/${result.draggableId}/${"section"}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCSRFToken(),
                },
            }).then((e) => {
                if (e.status === 200) {
                    e.json().then((rsp) => {
                        ormSectionLoadDetailChild(result.draggableId, function () {
                            _this.setState({ moving: false });
                        });
                    });
                } else {
                    _this.setState({ moving: false })
                }
            });
        }
    };

    render() {
        const {
            classes,
            ormSectionDelete,
            ormSectionCreate,
            ormSectionUpdate,
            ormFormUpdate,
            ormFormCreate,
            page,
            pages,
            sections,
            forms,
            history,
            ormSectionLoadDetailChild,
            ormSectionMapGroupingCreate,
            ormSectionMapGroupingUpdate,
            ormSectionMapGroupingDelete,
            ormGroupingValueCreate,
            ormGroupingValueUpdate,
            ormGroupingValueDelete,
            mapGroups,
            groupValues,
            authState,
        } = this.props;

        const {
            deleteDialogOpen,
            deleteDialogText,
            deleteDialogConfirmAction,
            openEditDialog,
            editDialog,
            newFormDialogOpen,
            moving
        } = this.state;

        return (
            <>
                <Grid
                    container
                    style={{ marginBottom: 16 }}
                >
                    <Grid item xs={12}>
                        <Button
                            className={classes.gutterBottom}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() =>
                                this.setState({
                                    openEditDialog: true,
                                    editDialog: null,
                                    showGeoColor: false,
                                    geoPoint: false,
                                    displayModule: false,
                                    geoHitFlag: true,
                                    attachmentHitFlag: true,
                                    chartHitFlag: true,
                                    contactHitFlag: true,
                                    autoSectionHitFlag: true,
                                    displayModuleHitFlag: true,
                                    AGOLHitFlag: true,
                                    disabledRepeatable: false,
                                })
                            }
                        >
                            <AddCircleOutlineIcon />
                            &nbsp;&nbsp;&nbsp;Add New Section
                        </Button>
                    </Grid>
                </Grid>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="section_list" type="section_list" key="section_list">
                        {(provided, snapshot) => (
                            <Accordion
                                style={{
                                    backgroundColor: snapshot.isDraggingOver ? "#4e4e4e" : "",
                                }}
                                defaultExpanded
                                expanded={true}
                            >
                                <AccordionSummary
                                    className={classes.titlePanel}
                                    classes={{ root: classes.expandedMargin }}
                                    style={{
                                        backgroundColor: "#333",
                                        borderRadius: 3,
                                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 0px, rgba(0, 0, 0, 0.2) 0px 1px 1px",
                                    }}>
                                    <table style={{ width: "100%" }}>
                                        {/* Table Header */}
                                        <tr>
                                            <td style={{ width: "10%" }}>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Section Name
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Forms
                                                </Typography>{" "}
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Primary
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Geometry
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Icon
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Attachments
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Contacts
                                                </Typography>
                                            </td>
                                            <td style={{ width: "10%" }}>
                                                <Typography variant="h5" style={{ fontSize: 18, color: "#fff" }}>
                                                    Chart
                                                </Typography>
                                            </td>
                                        </tr>
                                    </table>
                                </AccordionSummary>
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    style={getListStyle2(snapshot.isDraggingOver)}
                                >
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <table
                                                style={{
                                                    width: "100%",
                                                    marginTop: -3,
                                                    marginBottom: -3,
                                                    fontSize: "initial",
                                                }}>
                                                {sections.map((n) => {
                                                    const icon_array = ICON_LIST.find(function (itm) {
                                                        return itm.id === n.icon;
                                                    });
                                                    var icon_component;
                                                    if (icon_array) icon_component = icon_array["component"];

                                                    return (
                                                        <Draggable key={n.id} draggableId={n.id} index={n.order} /*isDragDisabled={disableDrag}*/>
                                                            {(provided, snapshot) => (
                                                                <div
                                                                    key={n.id}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={getItemStyle2(snapshot.isDragging, provided.draggableProps.style)}
                                                                    className={classes.fieldButton}
                                                                >
                                                                    <tr hover key={n.id} style={{ width: "100%", display: "inline-table" }}>
                                                                        <td className={classes.nowrap} style={{ width: "10%" }}>
                                                                            <Tooltip title="Drag and Drop Sections to Rearrange how they will look on the module">
                                                                                <img
                                                                                    style={{
                                                                                        width: "1.5em",
                                                                                        height: "1.6em",
                                                                                        verticalAlign: "middle",
                                                                                        marginRight: 11,
                                                                                        marginLeft: 6,
                                                                                    }}
                                                                                    src={drag}
                                                                                    alt="fireSpot"
                                                                                />
                                                                            </Tooltip>

                                                                            <Tooltip title="Edit">
                                                                                <Button
                                                                                    onClick={() =>
                                                                                        this.setState({
                                                                                            openEditDialog: true,
                                                                                            editDialog: n,
                                                                                            showGeoColor: false,
                                                                                            disabledRepeatable: false,
                                                                                            geoPoint: false,
                                                                                            displayModule: false,
                                                                                            geoHitFlag: true,
                                                                                        })
                                                                                    }
                                                                                    className={classes.deleteWidth}>
                                                                                    <EditIcon color="primary" />
                                                                                </Button>
                                                                            </Tooltip>

                                                                            <Tooltip title="Delete">
                                                                                <Button
                                                                                    onClick={() => this.deleteSection(n.id, n.name, n.parent)}
                                                                                    className={classes.deleteWidth}>
                                                                                    <DeleteIcon />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </td>
                                                                        <td style={{ width: "20%" }}>
                                                                            <Typography>{n.name}</Typography>
                                                                        </td>
                                                                        <td className={classes.nowrap} style={{ width: "10%" }}>
                                                                            <Tooltip title="Forms">
                                                                                <Button
                                                                                    className={classes.deleteWidth}
                                                                                    disabled={n.is_master_contact_form || n.is_time_series_chart}
                                                                                    // onClick={() => {
                                                                                    //     this.setState({
                                                                                    //         newFormDialogOpen: true,
                                                                                    //         clickedOnSection: n.id,
                                                                                    //     });
                                                                                    // }}
                                                                                    onClick={() => this.openNewFormDialog(n.id)}
                                                                                >
                                                                                    <EditIcon color="inherit" />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </td>
                                                                        {/* Primary CHECKBOX */}
                                                                        <td style={{ width: "10%" }}>
                                                                            <Checkbox
                                                                                checked={n.parent}
                                                                                disabled={true}
                                                                                label=""
                                                                                className={classes.deleteWidth}
                                                                            />
                                                                        </td>
                                                                        <td style={{ width: "10%" }}>
                                                                            <Checkbox
                                                                                checked={n.has_geometry}
                                                                                disabled={true}
                                                                                label=""
                                                                                className={classes.deleteWidth}
                                                                            />
                                                                        </td>
                                                                        <td style={{ width: "10%" }} className={classes.iconPush}>
                                                                            <ListItemIcon style={{ color: n.icon_color, display: 'block' }}>{icon_component}</ListItemIcon>
                                                                        </td>

                                                                        <td style={{ width: "10%" }}>
                                                                            <Checkbox
                                                                                checked={n.has_attachments}
                                                                                disabled={true}
                                                                                label=""
                                                                                className={classes.deleteWidth}
                                                                            />
                                                                        </td>
                                                                        <td style={{ width: "10%" }}>
                                                                            <Checkbox
                                                                                checked={n.is_contact_form || n.is_master_contact_form}
                                                                                disabled={true}
                                                                                label=""
                                                                                className={classes.deleteWidth}
                                                                            />
                                                                        </td>
                                                                        <td style={{ width: "10%" }}>
                                                                            <Checkbox
                                                                                checked={n.is_time_series_chart}
                                                                                disabled={true}
                                                                                label=""
                                                                                className={classes.deleteWidth}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    );
                                                })}
                                                {sections.length < 1 && (
                                                    <tr colSpan={9} className={classes.centerAlign}>
                                                        <td><Typography style={{ marginTop: 16, marginBottom: -16 }}>No Sections Defined</Typography></td>
                                                    </tr>
                                                )}
                                            </table>
                                        </Grid>
                                    </Grid>
                                </div>
                                {moving && (
                                    <Dialog open={moving}>
                                        <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                                            <Typography variant="h5" className={classes.flex}>
                                                Resaving Ordering
                                            </Typography>

                                            {/* <IconButton onClick={returnDialog}>
                                            <Close />
                                        </IconButton> */}
                                        </Toolbar>
                                        <DialogContent style={{ minWidth: 400 }}>
                                            <DialogContentText>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} style={{ textAlign: "center" }}>
                                                        <CircularProgress size={90} className={classes.progress} />
                                                        <Typography variant="h6" style={{ textAlign: "center" }}>
                                                            Please Wait...
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </DialogContentText>
                                        </DialogContent>
                                    </Dialog>
                                )}
                            </Accordion>
                        )}
                    </Droppable>
                </DragDropContext>

                {newFormDialogOpen && (
                    <AddNewForm //add new form component for adding to section
                        classes={classes}
                        open={newFormDialogOpen}
                        returnNewFormDialog={this.returnNewFormDialog}
                        ormFormCreate={ormFormCreate}
                        ormFormUpdate={ormFormUpdate}
                        page={page}
                        sections={sections}
                        forms={forms}
                        clickedOnSection={this.state.clickedOnSection}
                        history={history}
                        ormSectionLoadDetailChild={ormSectionLoadDetailChild}
                    />
                )}

                <SectionForm
                    classes={classes}
                    returnEditDialog={this.returnEditDialog}
                    returnDialog={this.returnEditDialog}
                    open={openEditDialog}
                    section={editDialog}
                    pages={pages}
                    page={page}
                    geoHitFlag={this.state.geoHitFlag}
                    showGeoColor={this.state.showGeoColor}
                    geoPoint={this.state.geoPoint}
                    displayModule={this.state.displayModule}
                    handleGeoColor={this.handleGeoColor}
                    handleMasterContacts={this.handleMasterContacts}
                    handleGeoType={this.handleGeoType}
                    handleDisplayModule={this.handleDisplayModule}
                    handleAttachmentTypes={this.handleAttachmentTypes}
                    handleChart={this.handleChart}
                    handleAutoSection={this.handleAutoSection}
                    handleAGOLQuestions={this.handleAGOLQuestions}
                    showAttachmentTypes={this.state.showAttachmentTypes}
                    showChartTypes={this.state.showChartTypes}
                    showAutoSectionCreate={this.state.showAutoSectionCreate}
                    showAGOLQuestions={this.state.showAGOLQuestions}
                    attachmentHitFlag={this.state.attachmentHitFlag}
                    chartHitFlag={this.state.chartHitFlag}
                    contactHitFlag={this.state.contactHitFlag}
                    AGOLHitFlag={this.state.AGOLHitFlag}
                    ormSectionMapGroupingDelete={ormSectionMapGroupingDelete}
                    ormSectionMapGroupingUpdate={ormSectionMapGroupingUpdate}
                    ormSectionMapGroupingCreate={ormSectionMapGroupingCreate}
                    ormGroupingValueCreate={ormGroupingValueCreate}
                    ormGroupingValueUpdate={ormGroupingValueUpdate}
                    ormGroupingValueDelete={ormGroupingValueDelete}
                    ormSectionCreate={ormSectionCreate}
                    ormSectionUpdate={ormSectionUpdate}
                    mapGroups={mapGroups}
                    groupValues={groupValues}
                    otherSections={sections}
                    authState={authState}
                    autoSectionHitFlag={this.state.autoSectionHitFlag}
                    displayModuleHitFlag={this.state.displayModuleHitFlag}
                    disabledRepeatable={this.state.disabledRepeatable}
                />

                <ParentWarningDialog
                    confirmAction={() => {
                        ormSectionDelete(deleteDialogConfirmAction);
                        this.setState({ deleteDialogOpen: false });
                    }}
                    cancelAction={() => this.setState({ deleteDialogOpen: false })}
                    open={deleteDialogOpen}
                    title={this.state.title ? "Delete Section" : ""} //dont display delete section if its a parent and there is children
                    text={deleteDialogText}
                    buttons={this.state.buttons} //pass whether or not to show buttons. True = show, false = dont show
                />
            </>
        );
    }
}

// // The add new form popup
// // http://localhost:3000/#/page/49
class AddNewForm extends Component {
    constructor() {
        super();
        this.state = {
            error: "",
            optimisticAdds: 0,
            addRowOpen: false,
        };
    }

    openAddRow = () => {
        this.setState((s) => (s.addRowOpen ? null : { addRowOpen: true, optimisticAdds: 1 }));
    };

    closeAddRow = () => {
        this.setState({ addRowOpen: false, optimisticAdds: 0 });
    };


    // When add button is hit
    createForm(values) {
        const {
            ormFormCreate,
            returnNewFormDialog,
            clickedOnSection,
            history,
            ormSectionLoadDetailChild,
        } = this.props;

        return ormFormCreate({
            section: parseInt(clickedOnSection, 10),
            name: values.name,
        }).then((formm) => {
            if (ormSectionLoadDetailChild) {
                ormSectionLoadDetailChild(parseInt(clickedOnSection, 10));
            }
            returnNewFormDialog();
            history.push("/form/" + clickedOnSection + "/" + formm.id);
            return formm;
        });
    }

    // when user clicks the edit icon
    openForm = (rowData) => {
        const { clickedOnSection, history } = this.props;
        if (!rowData?.id) return;
        history.push("/form/" + clickedOnSection + "/" + rowData.id);
    };

    // when user renames the form
    renameForm = (newValue, oldValue) => {
        const { clickedOnSection, forms, ormFormUpdate } = this.props;

        const sectionId = parseInt(clickedOnSection, 10);

        const match = (forms || []).find(
            (f) =>
                parseInt(f.section, 10) === sectionId &&
                String(f.name || "") === String(oldValue || "")
        );

        if (!match?.id) return;

        ormFormUpdate({ id: match.id, name: newValue });
    };


    errorValidator = (values) => {
        const { sections, clickedOnSection } = this.props;
        var value = {};
        if (values) value = values.name;

        const isRequired = (val) => {
            return !val ? "Required" : null;
        };
        const previouslyAdded = (val) => {
            return val ? "There is already a Form with that Name. Rename to continue..." : null;
        };

        const sectionId = parseInt(clickedOnSection, 10);

        const formNames = (this.props.forms || [])
            .filter((f) => parseInt(f.section, 10) === sectionId)
            .map((f) => String(f.name || "").trim());

        const previousName = formNames.filter((e) => {
            if (value) {
                if (e === value.trim()) {
                    return e;
                }
            }
            return null;
        });

        var valObj = {};
        var name = isRequired(value);
        var prevName = previouslyAdded(previousName[0]);

        if (name !== null) {
            valObj.name = name;
        } else if (prevName !== null) {
            valObj.name = prevName;
        } else {
            valObj.name = name;
        }

        return valObj;
    };
    setError = (error) => {
        //set error for same form name
        this.setState({ error });
    };


    componentDidUpdate(prevProps) {
        if (
            prevProps.clickedOnSection !== this.props.clickedOnSection ||
            (prevProps.open && !this.props.open)
        ) {
            if (this.state.addRowOpen) this.closeAddRow();
            return;
        }

        const sectionId = parseInt(this.props.clickedOnSection, 10);

        const prevCount = (prevProps.forms || []).filter(
            (f) => parseInt(f.section, 10) === sectionId
        ).length;

        const nextCount = (this.props.forms || []).filter(
            (f) => parseInt(f.section, 10) === sectionId
        ).length;

        if (this.state.addRowOpen && nextCount > prevCount) {
            this.closeAddRow();
        }
    }


    render() {
        const { classes, returnNewFormDialog, open, forms, sections, clickedOnSection, ormFormUpdate } = this.props;
        const { error } = this.state;

        var columns = [
            { title: "Id", field: "id", hidden: true },
            { title: "Form Name", field: "name" },
        ];

        const sectionId = parseInt(clickedOnSection, 10);
        const formNames = (forms || [])
            .filter((f) => parseInt(f.section, 10) === sectionId)
            .map((f) => ({ id: f.id, name: f.name }));


        //default object for checking if default is already set
        var defaultValues = {};
        if (sections.length === 0) {
            defaultValues.parent = true;
        }

        const section = (sections || []).find((s) => parseInt(s.id, 10) === sectionId);
        const onlyOneFormAllowed = !!section?.repeatable_subform;
        const blockAdd = onlyOneFormAllowed && formNames.length > 0;

        // parent form check
        const isParentForm = section?.parent === true;

        // New section for table for size change:
        const rowCount = formNames.length + (this.state.optimisticAdds || 0);

        const BASE = 250;
        const ROW_H = 48;

        const desired = BASE + Math.max(0, rowCount - 1) * ROW_H;

        const computedHeight = `min(max(${BASE}px, ${desired}px), 90vh)`;


        return (
            <Dialog
                open={open}
                // classes={{ paper: classes.minWidth }}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    style: {
                        resize: "both",
                        overflow: "hidden",
                        width: 700,
                        minWidth: 700,
                        maxWidth: "95vw",
                        height: computedHeight,
                        minHeight: 250,
                        maxHeight: "90vh",
                    },
                }}
            >
                <Toolbar
                    style={{
                        backgroundColor: "#d3d3d3",
                    }}
                >
                    {formNames.length === 0 && (
                        <Typography
                            variant="h5"
                            className={classes.flex}
                            style={{ marginLeft: "25%" }}
                        >
                            Create a New Form
                        </Typography>
                    )}
                    {formNames.length > 0 && (
                        <Typography
                            variant="h5"
                            className={classes.flex}
                            // style={{ marginLeft: "22%" }}
                        >
                            Create or Edit a Form
                        </Typography>
                    )}
                    <IconButton onClick={returnNewFormDialog}>
                        <Close />
                    </IconButton>
                </Toolbar>

                <DialogContent
                    className={classes.dialogMin}
                    style={{ overflow: "auto" }}
                >
                    <DialogContentText>
                        <Formm
                            getApi={(el) => (this.formApi = el)}
                            dontValidateOnMount="true"
                            validateOnSubmit="true"
                            validateError={this.errorValidator}
                            onSubmit={(values) => this.createForm(values)}>
                            {(formApi) => (
                                <form onSubmit={formApi.submitForm}>
                                    <div>
                                        <MaterialTable
                                            style={{
                                                marginLeft: -14,
                                                marginRight: -14,
                                                marginBottom: -8
                                            }}
                                            title=""
                                            columns={columns}
                                            data={formNames}
                                            options={{
                                                search: false,
                                                paging: false,
                                            }}

                                            components={{
                                                Toolbar: (props) => (
                                                    <div className={classes.materialTableToolbar}>
                                                        {blockAdd ? (
                                                            <div>
                                                            </div>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => {
                                                                    if (blockAdd) return;
                                                                    this.openAddRow();
                                                                    props?.actions?.find((a) => a.tooltip === "Add")?.onClick();
                                                                }}
                                                                fullWidth
                                                            >
                                                                Create New Form
                                                            </Button>
                                                        )}
                                                    </div>
                                                ),
                                                Action: (props) => (
                                                    <div className={classes.materialTableActions}>
                                                        <MTableAction {...props} />
                                                    </div>
                                                ),
                                            }}

                                            editable={
                                                blockAdd
                                                    ?
                                                    {}
                                                    :
                                                    {
                                                        onRowAdd: (newData) =>
                                                            new Promise((resolve, reject) => {
                                                                if (blockAdd) {
                                                                    reject();
                                                                    return;
                                                                }

                                                                const errs = this.errorValidator(newData);

                                                                if (errs.name === null) {
                                                                    this.createForm(newData)
                                                                        .then(() => resolve())
                                                                        .catch(() => {
                                                                            this.closeAddRow();
                                                                            reject();
                                                                        });
                                                                } else {
                                                                    this.setError(errs.name);
                                                                    reject();
                                                                }
                                                            }),

                                                        onRowAddCancelled: () => this.closeAddRow(),
                                                    }
                                            }
                                            cellEditable={{
                                                //only for renaming form
                                                onCellEditApproved: (newValue, oldValue, rowData) =>
                                                    new Promise((resolve) => {
                                                        if (rowData?.id) ormFormUpdate({ id: rowData.id, name: newValue });
                                                        setTimeout(resolve, 250);
                                                    }),

                                            }}
                                            icons={{
                                                Add: (props) => (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={blockAdd || this.state.addRowOpen}
                                                        onClick={() => {
                                                            if (blockAdd || this.state.addRowOpen) return;
                                                            this.openAddRow();
                                                            props?.actions?.find((a) => a.tooltip === "Add")?.onClick();
                                                        }}
                                                        fullWidth
                                                    >
                                                        Create New Form
                                                    </Button>
                                                ),
                                            }}
                                            actions={[
                                                {
                                                    icon: "edit",
                                                    iconProps: { color: "primary" },
                                                    tooltip: "Edit Form",
                                                    onClick: (event, rowData) => {
                                                        this.openForm(rowData);
                                                    },
                                                },
                                            ]}
                                        />

                                        {blockAdd && !isParentForm && (
                                            <div style={{ marginTop: 25 }}>
                                                Only one form can be created for this section. This setting can be found in the section <b>Configuration/Record Behavior</b> tab.
                                            </div>
                                        )}

                                        {blockAdd && isParentForm && (
                                            <div style={{ marginTop: 25 }}>
                                                Only one form can be created for a Parent section.
                                            </div>
                                        )}
                                        <div style={{ color: "red" }}>{error}</div>
                                    </div>
                                </form>
                            )}
                        </Formm>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

const SectionBox = ({ title, children }) => (
    <Paper
        elevation={0}
        style={{
            padding: 16,
            // marginTop: 16,
            marginTop: 5,
            border: "1px solid #e0e0e0",
            borderRadius: 4,
        }}
    >
        {title && (
            <Typography
                variant="subtitle1"
                gutterBottom
            >
                <strong><u>{title}</u></strong>
            </Typography>
        )}
        {children}
    </Paper>
);

const StickyTabs = ({ children }) => (
    <div
        style={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            background: "#fff",
            paddingBottom: 2,
        }}
    >
        {children}
    </div>
);


// Rewrite to combine AddSection aned EditSection into one component
class SectionForm extends Component {
    state = {
        syncLoading: false,
        repeatableChange: false,
        activeTab: 0,
    };

    typingTimer;
    typingTimer2;
    typingTimer3;
    typingTimer4;
    groupingRefs = {};

    handleSubmit = async (values) => {
        const {
            section,
            ormSectionCreate,
            ormSectionUpdate,
            returnDialog,
            returnEditDialog,
            page,
            otherSections,
        } = this.props;

        let newValues = { ...values };

        if (newValues.parent) {
            newValues.repeatable_subform = true;
        }

        if (!newValues.has_geometry && newValues.geo_color) {
            newValues.geo_color = "";
        }

        try {
            if (section && section.id) {
                await ormSectionUpdate({ id: section.id, ...newValues });
                returnEditDialog();
            } else {
                await ormSectionCreate({
                    page: page,
                    order: otherSections.length,
                    ...newValues,
                });
                returnDialog();
            }
        } catch (error) {
            console.error("Section save failed:", error);
            alert("An error occurred while saving. Please check your input and try again.");
            throw error; // Notifies react-form that submission failed
        }
    };

    errorValidator = (values) => {
        const { otherSections, section } = this.props;
        const isRequired = (val) => (!val ? "Required" : null);

        const checkCount = (c) =>
            c < 2
                ? null
                : (
                    <div>
                        <div>{"ERROR: Primary is in another Section, each Module can only have 'One' Primary."}</div>
                        <div>{"Deselect this 'Primary Section' to allow Saving of this Section"}</div>
                        <div>{"NOTE: to allow this Section to be the 'Primary' deselect the other Section first before Enabling this Section"}</div>
                    </div>
                );

        let count = 0;
        otherSections.forEach((p) => {
            if (!section || p.id !== section.id) {
                if (p.parent === true) count++;
            }
        });


        if (values.parent) count++;

        const specialchars = (name) => {
            const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            return specialChars.test(name);
        };

        const valObj = {
            name: specialchars(values.name)
                ? "Special characters '/[`!@#$%^&*()+-=[]{};':|,.<>/?~]' are not allowed in name"
                : isRequired(values.name),
            geo_color: values.has_geometry ? isRequired(values.geo_color) : null,

            parent: checkCount(count),
            attachment_types: values.has_attachments ? isRequired(values.attachment_types) : null,
        };

        if (valObj.attachment_types === "Required") window.scrollTo({ top: 0, behavior: "smooth" });

        return valObj;
    };

    updateTextValue = (id, value) => {
        const { ormGroupingValueUpdate } = this.props;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            ormGroupingValueUpdate({ id, label: value });
        }, 1000);
    };

    updateTextValue2 = (id, value) => {
        const { ormGroupingValueUpdate } = this.props;
        clearTimeout(this.typingTimer2);
        this.typingTimer2 = setTimeout(() => {
            ormGroupingValueUpdate({ id, value });
        }, 1000);
    };

    updateTextValue3 = (id, value) => {
        const { ormSectionMapGroupingUpdate } = this.props;
        clearTimeout(this.typingTimer3);
        this.typingTimer3 = setTimeout(() => {
            ormSectionMapGroupingUpdate({ id, group_name: value });
        }, 1000);
    };

    updateTextValue4 = (id, value) => {
        const { ormGroupingValueUpdate } = this.props;
        clearTimeout(this.typingTimer4);
        this.typingTimer4 = setTimeout(() => {
            ormGroupingValueUpdate({ id, point_size: value });
        }, 1000);
    };

    // createGrouping = () => {
    //     const { section, ormSectionMapGroupingCreate } = this.props;
    //     if (section.id) {
    //         ormSectionMapGroupingCreate({ section: section.id });
    //     }
    // };



    handleMasterContactsToggle = (enabled) => {
        // keep existing UI behavior
        this.props.handleMasterContacts(enabled);

        if (!this.formApi) return;

        if (enabled) {
            // Record Behavior: turn off append-to-prior and enforce single record 
            this.formApi.setValue("append_fields", false);
            this.formApi.setValue("repeatable_subform", false);

            this.formApi.setValue("is_time_series_chart", false);
            this.formApi.setValue("chart_section", null);
            this.formApi.setValue("time_series_field", null);
            this.formApi.setValue("chart_plot_fields", null);

            this.formApi.setValue("chart_line_width", '');
            this.formApi.setValue("chart_point_size", '');

            this.formApi.setValue("chart_line_width2", '');
            this.formApi.setValue("chart_point_size2", '');

            // Basics: clear attachments and types
            this.formApi.setValue("has_attachments", false);
            this.formApi.setValue("attachment_types", "");

            // Map & Legend: clear geometry-related settings
            this.formApi.setValue("has_geometry", false);
            this.formApi.setValue("geometry_type", "");
            this.formApi.setValue("geo_color", "");
            this.formApi.setValue("form_or_map", false);
            this.formApi.setValue("display_list", false);
            this.formApi.setValue("display_module", false);
            // this.formApi.setValue("display_module_page", []);
            this.formApi.setValue("on_by_default", false);
            this.formApi.setValue("show_label_on_map", false);
            // this.formApi.setValue("point_symbology", "");
            this.formApi.setValue("point_size", "");

            // ArcGIS/Mobile: clear AGOL fields
            this.formApi.setValue("agol_service", "");
            this.formApi.setValue("agol_username", "");
            this.formApi.setValue("agol_password", "");
            this.formApi.setValue("agol_referer", "");
            this.formApi.setValue("token_url", "");
            this.formApi.setValue("use_latlon", false);
            this.formApi.setValue("use_timestamp", false);
            this.formApi.setValue("is_enterprise", false);
            this.formApi.setValue("enterprise_id", "");
            this.formApi.setValue("enterprise_secret", "");
        } else if (!enabled) {
            // when disabling master contacts
            this.formApi.setValue("append_fields", true);
        }
    };


    createGrouping = async () => {
        const { section, ormSectionMapGroupingCreate } = this.props;

        if (!section?.id) return;

        const grouping = await ormSectionMapGroupingCreate({
            section: section.id,
        });

        this.setState({
            focusGroupingId: grouping.id,
        });
    };

    createGroupValue = (group_id) => {
        const { ormGroupingValueCreate } = this.props;
        ormGroupingValueCreate({ sectionmapgrouping: group_id });
    };

    componentDidUpdate(prevProps, prevState) {
        // reset tab when dialog opens
        if (!prevProps.open && this.props.open) {
            this.setState({ activeTab: 0 });
        }

        // scroll to newly created grouping
        const focusId = this.state.focusGroupingId;
        if (focusId && focusId !== prevState.focusGroupingId) {
            const tryScroll = () => {
                const ref = this.groupingRefs[focusId];
                if (ref?.current) {
                    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });

                    if (ref.current.focus) ref.current.focus({ preventScroll: true });

                    this.setState({ focusGroupingId: null });
                    return true;
                }
                return false;
            };

            if (!tryScroll()) setTimeout(tryScroll, 50);
        }
    }



    // -------- Render Basics Tab --------
    renderBasics = (formApi, sectionForm) => {
        const {
            showAttachmentTypes,
            otherSections,
            open,
            section,
            disabledRepeatable
        } = this.props;

        // ---------- Chart-related dropdown fields ----------
        let _fields = [];
        let _datefields = [];
        let _numberfields = [];

        // Utility to populate fields from a section
        const extractChartFields = (targetSection) => {
            targetSection._forms?.forEach((_f) => {
                _f.groups?.forEach((_g) => {
                    _g.fields?.forEach((fl) => {
                        // Used in field selector
                        _fields.push({
                            label: `${fl.name} (${targetSection.name})`,
                            value: fl.id.toString(),
                        });

                        const t = String(fl.type || "").trim();

                        const isDate =
                            t === "Date" ||
                            t === "Date/Time" ||
                            t === "Datetime" ||
                            t === "Date Time";

                        const isNumber =
                            t === "Numeric" ||
                            t === "Calculated" ||
                            t === "Currency" ||
                            t === "Decimal" ||
                            t === "Integer" ||
                            t === "Number";

                        if (isDate) {
                            _datefields.push({ label: fl.name, value: fl.id.toString() });
                        } else if (isNumber) {
                            // _numberfields.push({ label: fl.name, value: fl.id.toString() });
                            _numberfields.push({ label: fl.name, value: fl.id });
                        }
                    });
                });
            });
        };

        const chartSectionId = this.state.chart_section || sectionForm.chart_section || section?.chart_section;

        if (chartSectionId) {
            // Populate from the selected chart section
            otherSections
                .filter((s) => s && s.id.toString() === chartSectionId.toString())
                .forEach(extractChartFields);
        } else if (open && section?._forms) {
            // Edit mode fallback – populate from all sections so the dropdowns are not empty when the dialog first opens
            otherSections.forEach(extractChartFields);
        }

        const chartSectionOptions = otherSections
            .filter((s) => s && !s.is_time_series_chart && !s.is_master_contact_form)
            .map((s) => ({ label: s.name, value: s.id.toString() }));

        return (
            <Grid
                container
                spacing={2}
            >
                <Grid item xs={12}>
                    <SectionBox title="Basic Information">
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item xs={12}>
                                <TextField
                                    field="name"
                                    label={
                                        <HelpLabel
                                            inputLabel="Name"
                                            helpText="Name that appears in the user interface on the tabs within a module"
                                        />
                                    }
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Select
                                    field="icon"
                                    label={
                                        <HelpLabel
                                            inputLabel="Icon"
                                            helpText="Icon that appears in the user interface on the tabs within a module"
                                        />
                                    }
                                    options={MAKE_OPTIONS_ICON(ICON_LIST)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={12}>

                                {!sectionForm.parent && (
                                    <>
                                        <ColorPicker field="icon_color" label="Icon Color" />
                                        <Switch
                                            field="is_time_series_chart"
                                            name="is_time_series_chart"
                                            disabled={disabledRepeatable}
                                            label={
                                                <HelpLabel
                                                    inputLabel="Time Series Chart?"
                                                    helpText="This type of section is a chart containing time series points pulled in from another section"
                                                />
                                            }
                                            eventHandle={(e) => this.props.handleChart(e)}
                                        />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </SectionBox>



                    {sectionForm.is_time_series_chart ? (
                        <>
                            <SectionBox title="Time Series Settings">
                                <>
                                    <br />
                                    <Grid
                                        container
                                        spacing={2}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Select
                                                    field="chart_section"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Chart Section"
                                                            helpText="Section whose data will be used for the time series chart."
                                                        />
                                                    }
                                                    options={chartSectionOptions}
                                                    fullWidth
                                                    // eventHandle={(value) => this.setState({ chart_section: value })}
                                                    eventHandle={(value) => {
                                                        const chartSectionId = typeof value === "object" ? value.value : value;
                                                        this.setState({ chart_section: chartSectionId });

                                                        const selected = otherSections.find((s) => String(s.id) === String(chartSectionId));
                                                        if (!selected) return;

                                                        const dateOpts = [];
                                                        const numOpts = [];

                                                        selected._forms?.forEach((f) =>
                                                            f.groups?.forEach((g) =>
                                                                g.fields?.forEach((fl) => {
                                                                    const t = String(fl.type || "").trim();
                                                                    const isDate = t === "Date" || t === "Date/Time" || t === "Datetime" || t === "Date Time";
                                                                    const isNumber = t === "Numeric" || t === "Calculated" || t === "Currency" || t === "Decimal" || t === "Integer" || t === "Number";

                                                                    if (isDate) dateOpts.push({ label: fl.name, value: fl.id.toString() });
                                                                    if (isNumber) numOpts.push({ label: fl.name, value: fl.id.toString() });
                                                                })
                                                            )
                                                        );

                                                        if (!this.formApi.values.time_series_field && dateOpts.length === 1) {
                                                            this.formApi.setValue("time_series_field", dateOpts[0].value);
                                                        }

                                                        if ((!this.formApi.values.chart_plot_fields || this.formApi.values.chart_plot_fields.length === 0) && numOpts.length === 1) {
                                                            // this.formApi.setValue("chart_plot_fields", [numOpts[0].value]);
                                                            this.formApi.setValue("chart_plot_fields", String(numOpts[0].value));
                                                        }
                                                    }}

                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Select
                                                    field="time_series_field"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Time Series Field"
                                                            helpText="Date field used for the x-axis of the chart."
                                                        />
                                                    }
                                                    options={_datefields}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <ReactSelect
                                                    field="chart_plot_fields"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Chart Plot Field(s)"
                                                            helpText="Numeric fields to plot on the chart."
                                                        />
                                                    }
                                                    options={_numberfields}
                                                    isMulti
                                                    fullWidth
                                                    display_label={true}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <ColorPicker
                                                field="chart_line_color"
                                                label="Line Color"
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <ColorPicker
                                                field="chart_point_color"
                                                label="Point Color"
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                field="chart_line_width"
                                                fullWidth
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Line Size"
                                                        helpText="Thickness of the line in the time series chart"
                                                    />
                                                }

                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                field="chart_point_size"
                                                fullWidth
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Point Size"
                                                        helpText="Size of the points in the time series chart"
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <ColorPicker
                                                field="chart_line_color2"
                                                label="Secondary Line Color"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <ColorPicker
                                                field="chart_point_color2"
                                                label="Secondary Point Color"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                field="chart_line_width2"
                                                fullWidth
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Secondary Line Size"
                                                        helpText="Thickness of the secondary line in the time series chart"
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                field="chart_point_size2"
                                                fullWidth
                                                label={
                                                    <HelpLabel
                                                        inputLabel="Secondary Point Size"
                                                        helpText="Size of the secondary points in the time series chart"
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            More Options? <br />
                                            - Chart height <br />
                                            - Fill in area <br />
                                            - Reverse yaxis (negative to positive) <br />
                                            - Show/hide CartesianGrid (dotted lines on chart) <br />
                                            - Default yaxis domains?
                                        </Grid>
                                    </Grid>
                                </>
                            </SectionBox>
                        </>
                    ) : (
                        <>
                            <SectionBox title="Attachments & Iframe">
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>

                                        <Switch
                                            field="has_attachments"
                                            name="has_attachments"
                                            disabled={disabledRepeatable}
                                            label={
                                                <HelpLabel
                                                    inputLabel="Has Attachments?"
                                                    helpText="Attachments can be added to the record (i.e. PDF, .doc, jpg, etc.)"
                                                />
                                            }
                                            eventHandle={(e) => this.props.handleAttachmentTypes(e)}
                                        />


                                    </Grid>
                                    {showAttachmentTypes && (
                                        <Subquestion
                                            component={
                                                <TextField
                                                    field="attachment_types"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Attachment Types"
                                                            helpText="Enter a comma separated list of attachment types that will be used in a drop down for adding attachments (i.e. Drawing,Map,Letter,Photo)"
                                                        />
                                                    }
                                                    multiline
                                                    fullWidth
                                                />
                                            }
                                        />
                                    )}
                                    <br />
                                    <Grid item xs={12}>
                                        <TextField
                                            field="iframe_url_section"
                                            label="(Optional) Configure section as an iframe - enter URL"
                                            fullWidth
                                        />
                                    </Grid>

                                </Grid>
                            </SectionBox>
                        </>
                    )}
                </Grid>
            </Grid>
        );
    };


    // -- Render Record Behavior Settings Tab --
    renderRecordBehavior = (formApi, sectionForm) => {
        const {
            disabledRepeatable,
            otherSections,
            section,
            showAutoSectionCreate,
            authState,
        } = this.props;

        const isParentSection =
            sectionForm.parent !== undefined
                ? sectionForm.parent
                : section?.parent || false;

        const isExistingChildSection = !!section && !section.parent;

        const autoCreateSections = otherSections
            .filter((s) => s && s.parent === false && !s.is_master_contact_form)
            .map((s) => s.name);

        var defaultValues = {
            repeatable_subform: true,
            append_fields: true,
            tableview_rowsperpage: 25,
            repeatable_rowsperpage: 10
        };

        if (otherSections.length === 0) {
            defaultValues.parent = true;
        }

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SectionBox title="Record Behavior">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Switch
                                    field="append_fields"
                                    name="append_fields"
                                    disabled={disabledRepeatable}
                                    label={
                                        <HelpLabel
                                            inputLabel="Append New Fields to Prior Records?"
                                            helpText="Attach new form field to all records that were previously created "
                                        />
                                    }
                                />
                            </Grid>

                            {!isParentSection && (
                                <Switch
                                    field="repeatable_subform"
                                    name="repeatable_subform"
                                    disabled={disabledRepeatable}
                                    label={
                                        <HelpLabel
                                            inputLabel="Only Allow One Record to be Created in the Section"
                                            helpText={
                                                <div>
                                                    Toggling this setting to 'No' will allow the creation of many sub-records in the section.
                                                    <br />
                                                    <br />
                                                    Toggling this to 'No' is most useful when the intention of the section is to store many
                                                    sub-records to the parent record. Some typical examples are:
                                                    <ul>
                                                        <li>creating many inspections for a permit</li>
                                                        <li>creating many maintenance records for a facility</li>
                                                        <li>creating a correspondence log</li>
                                                    </ul>
                                                    If you're unsure how to use this setting, please contact MS4Front support.
                                                </div>
                                            }
                                        />
                                    }
                                    eventHandle={
                                        isExistingChildSection ? (e) => this.setState({ repeatableChange: e }) : undefined
                                    }
                                />
                            )}

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Select
                                        field="tableview_rowsperpage"
                                        label={
                                            <HelpLabel
                                                inputLabel="Default Table View Rows Per Page"
                                                helpText="Total records to be seen before pagination. Note: for one recordsection sections this will not be applicable"
                                            />
                                        }
                                        options={MAKE_OPTIONS_CUST(["10", "25", "50", "100"])}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Select
                                        field="repeatable_rowsperpage"
                                        label={
                                            <HelpLabel
                                                inputLabel="Default Repeatable Rows Per Page"
                                                helpText="Total records to be seen before pagination"
                                            />
                                        }
                                        options={MAKE_OPTIONS_CUST(["5", "10", "15", "20", "25", "50"])}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            {(defaultValues.parent || (section && section.parent)) && (
                                <> {section && section.parent && (
                                    <Switch
                                        field="autocreate_another_section_record"
                                        name="autocreate_another_section_record"
                                        label={
                                            <HelpLabel
                                                inputLabel="Auto Create Related Record for every Primary Created Record"
                                                helpText="Related record will be created for every new primary/parent record creation. This should only be used when the related section is setup to allow for one record OR the related section has only one form."
                                            />
                                        }
                                        eventHandle={(e) => this.props.handleAutoSection(e)}

                                    />
                                )}
                                    {showAutoSectionCreate && (
                                        <Subquestion
                                            component={
                                                <Select
                                                    field="autocreate_section"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Choose the section to auto create"
                                                            helpText="This chosen section will be auto created for every primary record creation and is only applicable for desktop primary record creation."
                                                        />
                                                    }
                                                    options={MAKE_OPTIONS_CUST(autoCreateSections)}
                                                    fullWidth
                                                />
                                            }
                                        />
                                    )}
                                </>
                            )}

                            {(authState.auth.user.use_master_contacts && !sectionForm.parent) && (
                                <Switch
                                    field="is_master_contact_form"
                                    name="is_master_contact_form"
                                    label={
                                        <HelpLabel
                                            inputLabel="Use Master Contacts?"
                                            helpText="Selecting this will prevent you from adding custom forms and use the configuration from the master contacts list"
                                        />
                                    }
                                    eventHandle={(e) => {
                                        this.handleMasterContactsToggle(e);
                                    }}
                                />
                            )}

                            {((defaultValues.parent || sectionForm.parent) && (
                                <Switch
                                    field="has_confirmation"
                                    name="has_confirmation"
                                    label={
                                        <HelpLabel
                                            inputLabel="Show Confirmation During Record Creation"
                                            helpText="Shows a confirmation dialog when creating a new record to avoid accidental creation. This setting is ignored if there are multiple forms configured for the section."
                                        />
                                    }
                                />
                            ))}
                        </Grid>
                    </SectionBox>
                </Grid>
            </Grid>
        );
    }


    // ---------------------------------- Map Settings ----------------------------------
    renderMapSettings = (formApi, sectionForm) => {
        const {
            showGeoColor,
            geoPoint,
            handleDisplayModule,
            displayModule,
            pages,
            section,
            mapGroups,
            otherSections,
            classes,
            groupValues,
            ormSectionMapGroupingUpdate,
            ormGroupingValueUpdate,
            ormSectionMapGroupingDelete,
            ormGroupingValueDelete,
        } = this.props;
        let _fields = [];
        let _datefields = [];
        let _numberfields = [];
        const isEdit = !!section?.id;

        // Utility to populate fields from a section
        const extractChartFields = (targetSection) => {
            targetSection._forms?.forEach((_f) => {
                _f.groups?.forEach((_g) => {
                    _g.fields?.forEach((fl) => {
                        // Used in field selector
                        _fields.push({ label: `${fl.name} (${targetSection.name})`, value: fl.id.toString() });

                        const t = String(fl.type || "").trim();

                        const isDate =
                            t === "Date" ||
                            t === "Date/Time" ||
                            t === "Datetime" ||
                            t === "Date Time";

                        const isNumber =
                            t === "Numeric" ||
                            t === "Calculated" ||
                            t === "Currency" ||
                            t === "Decimal" ||
                            t === "Integer" ||
                            t === "Number";

                        if (isDate) {
                            _datefields.push({ label: fl.name, value: fl.id.toString() });
                        } else if (isNumber) {
                            // _numberfields.push({ label: fl.name, value: fl.id.toString() });
                            _numberfields.push({ label: fl.name, value: fl.id });
                        }
                    });
                });
            });
        };

        var defaultValues = { repeatable_subform: true, append_fields: true, tableview_rowsperpage: 25, repeatable_rowsperpage: 10 };
        if (otherSections.length === 0) {
            defaultValues.parent = true;
        }

        // if (section && section._forms) {
        //     extractChartFields(section);
        // }

        // const seen = new Set();
        // _fields = _fields.filter(opt => {
        //     const k = String(opt.value);
        //     if (seen.has(k)) return false;
        //     seen.add(k);
        //     return true;
        // });

        // _fields.sort((a, b) => String(a.label).localeCompare(String(b.label)));



        const sourceSections = (otherSections && otherSections.length)
            ? otherSections
            : (section ? [section] : []);

        sourceSections.forEach(extractChartFields);

        const sectionSort = (s) => ({
            isParent: s.parent === true ? 1 : 0,
            order: Number.isFinite(s.order) ? s.order : 999999,
            name: String(s.name || ""),
        });

        const orderedSections = [...sourceSections].sort((a, b) => {
            const A = sectionSort(a);
            const B = sectionSort(b);

            // parent
            if (A.isParent !== B.isParent) return B.isParent - A.isParent;

            // section
            if (A.order !== B.order) return A.order - B.order;

            // fallback(stable-ish)
            return A.name.localeCompare(B.name);
        });

        let _fieldsWithMeta = [];

        orderedSections.forEach((targetSection) => {
            targetSection._forms?.forEach((_f) => {
                _f.groups?.forEach((_g) => {
                    _g.fields?.forEach((fl) => {
                        _fieldsWithMeta.push({
                            label: `${fl.name} (${targetSection.name})`,
                            value: fl.id.toString(),
                            __sectionIsParent: targetSection.parent === true ? 1 : 0,
                            __sectionOrder: Number.isFinite(targetSection.order) ? targetSection.order : 999999,
                            __sectionName: String(targetSection.name || ""),
                            __fieldName: String(fl.name || ""),
                            __fieldOrder: Number.isFinite(fl.order) ? fl.order : 999999,
                        });
                    });
                });
            });
        });

        const seen = new Set();

        _fieldsWithMeta = _fieldsWithMeta.filter((opt) => {
            const k = String(opt.value);
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
        });

        _fieldsWithMeta.sort((a, b) => {
            if (a.__sectionIsParent !== b.__sectionIsParent) return b.__sectionIsParent - a.__sectionIsParent;
            if (a.__sectionOrder !== b.__sectionOrder) return a.__sectionOrder - b.__sectionOrder;

            if (a.__fieldOrder !== b.__fieldOrder) return a.__fieldOrder - b.__fieldOrder;
            return a.__fieldName.localeCompare(b.__fieldName);
        });

        _fields = _fieldsWithMeta.map(({ label, value }) => ({ label, value }));


        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SectionBox title="Map Location Settings for this Section">
                        <Grid container>
                            <Grid item xs={12}>
                                <Switch
                                    field="has_geometry"
                                    name="has_geometry"
                                    label={
                                        <HelpLabel
                                            inputLabel="Include Map Location?"
                                            helpText="Store a map geometry to represent a location of the record."
                                        />
                                    }
                                    eventHandle={(e) => this.props.handleGeoColor(e)}
                                />
                            </Grid>
                        </Grid>
                        {showGeoColor && (
                            <>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Subquestion
                                            component={
                                                <Select
                                                    field="geometry_type"
                                                    disabled={sectionForm?.is_locked || false}
                                                    options={MAKE_OPTIONS_CUST(["Point", "MultiPoint", "Line", "Polygon"])}
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Geometry Type"
                                                            helpText="Digitizing locations on the map will be restricted to this geometry type."
                                                        />
                                                    }
                                                    fullWidth
                                                    eventHandle={(e) => this.props.handleGeoType(e)}
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Switch
                                            field="form_or_map"
                                            name="form_or_map"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Enter Form by Default"
                                                    helpText="If Yes, when you add a new record you will be redirected to the form view."
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Switch
                                            field="display_list"
                                            name="display_list"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Include Section on Map Legend?"
                                                    helpText="If Yes, the section will appear in the map legend."
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Switch
                                            field="display_module"
                                            name="display_module"
                                            eventHandle={(e) => {
                                                handleDisplayModule(e);
                                            }}
                                            label={
                                                <HelpLabel
                                                    inputLabel="Include Section Within Other Modules?"
                                                    helpText="Switch to Yes if you would like to view this section inside the map of a different module."
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                {displayModule && (
                                    <Grid container>
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={11}>
                                            <ReactSelect
                                                label="Which Other Modules?"
                                                field="display_module_page"
                                                options={MAKE_OPTIONS(pages)}
                                                isMulti={true}
                                                fullWidth
                                                display_label={true}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Switch
                                            field="on_by_default"
                                            name="on_by_default"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Map Layer On by Default?"
                                                    helpText="If Yes, this section’s map layer will be turned on by default."
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <Switch
                                            field="show_label_on_map"
                                            name="show_label_on_map"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Show Identification Label on Map"
                                                    helpText="If Yes, the selected label will display with the geometry on the map."
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={11}>
                                        <ColorPicker
                                            field="geo_color"
                                            label={
                                                <span>
                                                    Map Layer Color <span style={{ color: "#d32f2f" }}>*</span>
                                                </span>
                                            }
                                        />
                                    </Grid>
                                </Grid>


                                {geoPoint && (
                                    <>
                                        <Grid container>
                                            <Grid item xs={1}></Grid>
                                            <Grid item xs={11}>
                                                <Select
                                                    field="point_symbology"
                                                    options={MAKE_OPTIONS_CUST([
                                                        "Circle",
                                                        "Triangle",
                                                        "Square",
                                                        "Cross",
                                                        "Diamond",
                                                        "X",
                                                    ])}
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Point Symbology"
                                                            helpText="What type of point should this layer be displayed on the map as."
                                                        />
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={1}></Grid>
                                            <Grid item xs={11}>
                                                <TextField
                                                    field="point_size"
                                                    style={{ marginTop: 16 }}
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Point Size"
                                                            helpText="(Integer) How large the point is deisplayed on the map. The default size depends on the point symbology. Square/Cross/X defaults to 8. Circle/Triangle/Diamond defaults to 12."
                                                        />
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>

                                        {
                                            !isEdit && (
                                                <Grid container>
                                                    <Grid item xs={1}></Grid>
                                                    <Grid item xs={11}>
                                                        <br />
                                                        <Typography
                                                            className={classes.italics}
                                                        >
                                                            Map Groupings are only available after the section has been saved. Please save and reopen the section to configure.
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                    </>
                                )}
                                <br />

                                {showGeoColor && (
                                    <>
                                        {/* <Grid container style={{ padding: "8px 0" }}>
                                                            <Grid item xs={6}>
                                                                <Typography variant="h4" gutterBottom>
                                                                    Map Groupings
                                                                </Typography>
                                                                <Button onClick={() => this.createGrouping()} variant="contained" color="primary" fullWidth>
                                                                    <AddCircleOutlineIcon />
                                                                    &nbsp;&nbsp;Add New Map Grouping
                                                                </Button>
                                                            </Grid>
                                                        </Grid> */}
                                        {section?.id && (
                                            <Grid container style={{ padding: "8px 0" }}>
                                                <Grid item xs={6}>
                                                    <Typography variant="h4" gutterBottom>
                                                        Map Groupings
                                                    </Typography>
                                                    <Button
                                                        onClick={() => this.createGrouping()}
                                                        variant="contained"
                                                        color="primary"
                                                        fullWidth
                                                    >
                                                        <AddCircleOutlineIcon />
                                                        &nbsp;&nbsp;Add New Map Grouping
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {mapGroups
                                            .filter((mg) => mg.section === section?.id)
                                            .map((group) => {
                                                console.log("group:", group);
                                                if (!this.groupingRefs[group.id]) {
                                                    this.groupingRefs[group.id] = React.createRef();
                                                }
                                                return (
                                                    <Grid
                                                        // container
                                                        // style={{ border: "1px dotted", padding: "8px", marginBottom: 16 }}
                                                        key={group.id}
                                                        ref={this.groupingRefs[group.id]}
                                                        tabIndex={-1}
                                                        container
                                                        style={{
                                                            border: "1px dotted",
                                                            padding: 8,
                                                            marginBottom: 16,
                                                        }}
                                                    >
                                                        <Grid item xs={12}>
                                                            <Formm defaultValues={group}>
                                                                {(formApiChild) => (
                                                                    <form onSubmit={formApiChild.submitForm}>
                                                                        <Grid
                                                                            container
                                                                        >
                                                                            <Grid item xs={5}>
                                                                                <Select
                                                                                    field="field_id"
                                                                                    label={
                                                                                        <HelpLabel
                                                                                            inputLabel="Field to Filter By"
                                                                                            helpText="Field to filter Layer records on. Only one field can be used as the filter for the group."
                                                                                        />
                                                                                    }
                                                                                    eventHandle={(e) => {
                                                                                        ormSectionMapGroupingUpdate({
                                                                                            id: group.id,
                                                                                            field_id: e,
                                                                                        });
                                                                                    }}
                                                                                    options={_fields}
                                                                                    fullWidth
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={6}>
                                                                                <TextField
                                                                                    field="group_name"
                                                                                    eventHandle={(e) => {
                                                                                        this.updateTextValue3(group.id, e);
                                                                                    }}
                                                                                    label={
                                                                                        <HelpLabel
                                                                                            inputLabel="Grouping Name"
                                                                                            helpText="The name of the layer group that appears in the legend."
                                                                                        />
                                                                                    }
                                                                                    fullWidth
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={1}>
                                                                                <Tooltip title="Delete Grouping">
                                                                                    <Button
                                                                                        onClick={() => ormSectionMapGroupingDelete(group.id)}
                                                                                        style={{ float: "right", marginTop: 12 }}
                                                                                        className={classes.deleteWidth}>
                                                                                        <DeleteIcon />
                                                                                    </Button>
                                                                                </Tooltip>
                                                                            </Grid>
                                                                            <Grid item xs={12} style={{ marginTop: 8 }}>
                                                                                <Button
                                                                                    onClick={() => this.createGroupValue(group.id)}
                                                                                    variant="contained"
                                                                                    color="primary">
                                                                                    Add New Legend Item
                                                                                    <AddCircleOutlineIcon />
                                                                                </Button>
                                                                                <Switch
                                                                                    field="collapsed_by_default"
                                                                                    name="collapsed_by_default"
                                                                                    style={{ marginTop: -5, width: "auto", marginLeft: 8 }}
                                                                                    eventHandle={(e) => {
                                                                                        ormSectionMapGroupingUpdate({
                                                                                            id: group.id,
                                                                                            collapsed_by_default: e,
                                                                                        });
                                                                                    }}
                                                                                    label={
                                                                                        <HelpLabel
                                                                                            inputLabel="Grouping Collapsed By Default?"
                                                                                            helpText="If this parameter is switched to true this map grouping will be collapsed when initally entering the map."
                                                                                        />
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            {groupValues
                                                                                .filter((gv) => gv.sectionmapgrouping === group.id)
                                                                                .map((gValue) => {
                                                                                    return (
                                                                                        <Grid item xs={12} style={{ marginTop: 8 }}>
                                                                                            <Formm defaultValues={gValue}>
                                                                                                {(formApiChild2) => (
                                                                                                    <form onSubmit={formApiChild2.submitForm}>
                                                                                                        <Grid container>
                                                                                                            <Grid item xs={7}>
                                                                                                                <TextField
                                                                                                                    field="label"
                                                                                                                    eventHandle={(e) => {
                                                                                                                        this.updateTextValue(
                                                                                                                            gValue.id,
                                                                                                                            e
                                                                                                                        );
                                                                                                                    }}
                                                                                                                    label={
                                                                                                                        <HelpLabel
                                                                                                                            inputLabel="Map Legend Label"
                                                                                                                            helpText="The name of the layer that appears in the map legend."
                                                                                                                        />
                                                                                                                    }
                                                                                                                    fullWidth
                                                                                                                />
                                                                                                                <TextField
                                                                                                                    field="value"
                                                                                                                    style={{ marginTop: 16 }}
                                                                                                                    eventHandle={(e) => {
                                                                                                                        this.updateTextValue2(
                                                                                                                            gValue.id,
                                                                                                                            e
                                                                                                                        );
                                                                                                                    }}
                                                                                                                    label={
                                                                                                                        <HelpLabel
                                                                                                                            inputLabel="Filter Value"
                                                                                                                            helpText="List of unique values to filter records on. The list of values creates an 'or' search and filters the records to display on that list. Values in the list need to be separated with these characters |||. For example a range of years would be: 2018|||2019|||2020|||2021"
                                                                                                                        />
                                                                                                                    }
                                                                                                                    fullWidth
                                                                                                                />
                                                                                                            </Grid>
                                                                                                            <Grid item xs={4}>
                                                                                                                <Grid container>
                                                                                                                    <Grid item xs={6}>
                                                                                                                        <ColorPicker
                                                                                                                            field="geo_color"
                                                                                                                            eventHandle={(
                                                                                                                                e
                                                                                                                            ) => {
                                                                                                                                ormGroupingValueUpdate(
                                                                                                                                    {
                                                                                                                                        id: gValue.id,
                                                                                                                                        geo_color:
                                                                                                                                            e,
                                                                                                                                    }
                                                                                                                                );
                                                                                                                            }}
                                                                                                                            label="Map Layer Color"
                                                                                                                        />
                                                                                                                    </Grid>
                                                                                                                    <Grid item xs={6}>
                                                                                                                        <Switch
                                                                                                                            field="on_by_default"
                                                                                                                            name="on_by_default"
                                                                                                                            style={{
                                                                                                                                marginTop: 0,
                                                                                                                                marginBottom: 3,
                                                                                                                                width: "auto",
                                                                                                                            }}
                                                                                                                            eventHandle={(e) => {
                                                                                                                                ormGroupingValueUpdate(
                                                                                                                                    {
                                                                                                                                        id: gValue.id,
                                                                                                                                        on_by_default:
                                                                                                                                            e,
                                                                                                                                    }
                                                                                                                                );
                                                                                                                            }}
                                                                                                                            label="Layer on by Default"
                                                                                                                        />
                                                                                                                    </Grid>
                                                                                                                    {geoPoint && (
                                                                                                                        <>
                                                                                                                            <Grid
                                                                                                                                item
                                                                                                                                xs={12}>
                                                                                                                                <Select
                                                                                                                                    field="point_symbology"
                                                                                                                                    options={MAKE_OPTIONS_CUST(
                                                                                                                                        [
                                                                                                                                            "Circle",
                                                                                                                                            "Triangle",
                                                                                                                                            "Square",
                                                                                                                                            "Cross",
                                                                                                                                            "Diamond",
                                                                                                                                            "X",
                                                                                                                                        ]
                                                                                                                                    )}
                                                                                                                                    label={
                                                                                                                                        <HelpLabel
                                                                                                                                            inputLabel="Point Symbology"
                                                                                                                                            helpText="What type of point should this layer be displayed on the map as."
                                                                                                                                        />
                                                                                                                                    }
                                                                                                                                    fullWidth
                                                                                                                                    eventHandle={(e) => {
                                                                                                                                        ormGroupingValueUpdate(
                                                                                                                                            {
                                                                                                                                                id: gValue.id,
                                                                                                                                                point_symbology:
                                                                                                                                                    e,
                                                                                                                                            }
                                                                                                                                        );
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </Grid>
                                                                                                                            <Grid
                                                                                                                                item
                                                                                                                                xs={12}>
                                                                                                                                <TextField
                                                                                                                                    field="point_size"
                                                                                                                                    style={{
                                                                                                                                        marginTop: 16,
                                                                                                                                    }}
                                                                                                                                    label={
                                                                                                                                        <HelpLabel
                                                                                                                                            inputLabel="Point Size"
                                                                                                                                            helpText="(Integer) How large the point is displayed on the map. The default size depends on the point symbology. Square/Cross/X defaults to 8. Circle/Triangle/Diamond defaults to 12."
                                                                                                                                        />
                                                                                                                                    }
                                                                                                                                    fullWidth
                                                                                                                                    eventHandle={(e) => {
                                                                                                                                        this.updateTextValue4(
                                                                                                                                            gValue.id,
                                                                                                                                            e
                                                                                                                                        );
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </Grid>
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </Grid>
                                                                                                            </Grid>
                                                                                                            <Grid item xs={1}>
                                                                                                                <Tooltip title="Delete Value">
                                                                                                                    <Button
                                                                                                                        style={{
                                                                                                                            float: "right",
                                                                                                                            marginTop: 12,
                                                                                                                        }}
                                                                                                                        onClick={() =>
                                                                                                                            ormGroupingValueDelete(
                                                                                                                                gValue.id
                                                                                                                            )
                                                                                                                        }
                                                                                                                        className={
                                                                                                                            classes.deleteWidth
                                                                                                                        }>
                                                                                                                        <DeleteIcon />
                                                                                                                    </Button>
                                                                                                                </Tooltip>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                    </form>
                                                                                                )}
                                                                                            </Formm>
                                                                                        </Grid>
                                                                                    );
                                                                                })}
                                                                        </Grid>
                                                                    </form>
                                                                )}
                                                            </Formm>
                                                        </Grid>
                                                    </Grid>
                                                );
                                            })}
                                    </>
                                )}

                            </>
                        )}
                    </SectionBox>
                </Grid>
            </Grid >
        );
    };


    // -- Render Mobile Settings Tab --
    renderMobileSettings = (formApi, sectionForm) => {
        const {
            showAGOLQuestions,
            section,
            otherSections,
            authState,
        } = this.props;
        const { syncLoading } = this.state;
        let _fields = [];
        let _datefields = [];
        let _numberfields = [];

        const extractChartFields = (targetSection) => {
            targetSection._forms?.forEach((_f) => {
                _f.groups?.forEach((_g) => {
                    _g.fields?.forEach((fl) => {
                        // Used in field selector
                        _fields.push({ label: `${fl.name} (${targetSection.name})`, value: fl.id.toString() });

                        const t = String(fl.type || "").trim();

                        const isDate =
                            t === "Date" ||
                            t === "Date/Time" ||
                            t === "Datetime" ||
                            t === "Date Time";

                        const isNumber =
                            t === "Numeric" ||
                            t === "Calculated" ||
                            t === "Currency" ||
                            t === "Decimal" ||
                            t === "Integer" ||
                            t === "Number";

                        if (isDate) {
                            _datefields.push({ label: fl.name, value: fl.id.toString() });
                        } else if (isNumber) {
                            // _numberfields.push({ label: fl.name, value: fl.id.toString() });
                            _numberfields.push({ label: fl.name, value: fl.id });
                        }
                    });
                });
            });
        };

        if (section && section._forms) {
            extractChartFields(section);
        }

        var defaultValues = { repeatable_subform: true, append_fields: true, tableview_rowsperpage: 25, repeatable_rowsperpage: 10 };
        if (otherSections.length === 0) {
            defaultValues.parent = true;
        }

        const formId = section?._forms?.[0]?.id;

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SectionBox title="Mobile Forms Setting for this Section">
                        <Switch
                            field="is_contact_form"
                            name="is_contact_form"
                            label={
                                <HelpLabel
                                    inputLabel="Include Contact Emails in Mobile Form?"
                                    helpText="If Yes, contact email fields will be added to the mobile form."
                                />
                            }
                        />
                        <br />
                        <br />
                        <Grid
                            container
                            sx={{
                                paddingTop: 5,
                            }}
                        >
                            <Grid item xs={11}>
                                <TextField
                                    field="agol_service"
                                    label={
                                        <HelpLabel
                                            inputLabel="ArcGIS Online Service"
                                            helpText="Full REST URL to the ArcGIS online fature service. Ex: https://services2.arcgis.com/rwqARsO7kmPlpMQS/ArcGIS/rest/services/service_e765080ef4ca4aa0937cf8122551a902/FeatureServer/0/"
                                        />
                                    }
                                    multiline
                                    fullWidth
                                    eventHandle={(e) => this.props.handleAGOLQuestions(e)}
                                />
                            </Grid>
                        </Grid>

                        {showAGOLQuestions && (
                            <Box
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "16px",
                                    marginTop: "16px",
                                    backgroundColor: "#f9f9f9",
                                }}
                            >
                                <Grid container style={{ padding: "8px 0" }}>
                                    <Grid item xs={1} style={{ maxWidth: "5%" }}></Grid>
                                    <Grid item xs={11}>
                                        <TextField field="agol_username" label="ArcGIS Username" multiline fullWidth />
                                    </Grid>
                                </Grid>
                                <Grid container style={{ padding: "8px 0" }}>
                                    <Grid item xs={1} style={{ maxWidth: "5%" }}></Grid>
                                    <Grid item xs={11}>
                                        <TextField field="agol_password" label="ArcGIS Password" multiline fullWidth />
                                    </Grid>
                                </Grid>


                                <Grid container style={{ padding: "8px 0" }}>
                                    <Grid item xs={1} style={{ maxWidth: "5%" }}></Grid>
                                    <Grid item xs={11}>
                                        <TextField field="agol_referer" label="ArcGIS Referrer" multiline fullWidth />
                                    </Grid>
                                </Grid>
                                <Grid container style={{ padding: "8px 0" }}>
                                    <Grid item xs={1} style={{ maxWidth: "5%" }}></Grid>
                                    <Grid item xs={11}>
                                        <TextField
                                            field="token_url"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Custom Token URL"
                                                    helpText="If your organization has a self hosted ArcGIS rest service that uses token authentication paste the URL of where tokens can be generated."
                                                />
                                            }
                                            multiline
                                            fullWidth
                                        />
                                        <Switch
                                            field="use_latlon"
                                            name="use_latlon"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Transform Geometry to WGS84 (Lat/Lon)"
                                                    helpText="If you published your rest service using WGS84 check this. (rare use case)"
                                                />
                                            }
                                        />
                                        <Switch
                                            field="use_timestamp"
                                            name="use_timestamp"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Sync date fields as datetime"
                                                    helpText="Prior to August 2023 by default date fields were synced to ArcGIS Online as text. If you have set up the feature service after that date or are using esriFieldTypeDate for date fields this should be set to Yes."
                                                />
                                            }
                                        />
                                        <Switch
                                            field="is_enterprise"
                                            name="is_enterprise"
                                            label={
                                                <HelpLabel
                                                    inputLabel="Is ArcGIS Enterprise"
                                                    helpText="If your organization is using ArcGIS Enterprise version provide the enterprise ID and enterprise secret below."
                                                />
                                            }
                                        />
                                        <TextField field="enterprise_id" label="Enterprise ID" multiline fullWidth />
                                    </Grid>
                                </Grid>
                                <Grid container style={{ padding: "8px 0" }}>
                                    <Grid item xs={1} style={{ maxWidth: "5%" }}></Grid>
                                    <Grid item xs={11}>
                                        <TextField field="enterprise_secret" label="Enterprise Secret" multiline fullWidth />
                                        {section && (
                                            <Grid container style={{ marginTop: 16 }} spacing={2}>
                                                <Grid item xs={6}>
                                                    <Button
                                                        fullWidth
                                                        disabled={!formId}
                                                        onClick={() => {
                                                            if (!formId) return;
                                                            window.open(`/excel/form/${formId}/json/${section.id}/True`);
                                                        }}
                                                    >
                                                        Download Feature Service JSON File
                                                    </Button>

                                                    {!formId && (
                                                        <Typography style={{ marginTop: 8, fontStyle: "italic" }}>
                                                            Add at least one form to this section to enable JSON export.
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {syncLoading ? (
                                                        <>
                                                            <CircularProgress
                                                                size={24}
                                                                style={{ display: "table", marginLeft: "auto", marginRight: "auto" }}
                                                            />
                                                            Loading Please Wait... This may take several minutes up to several hours
                                                            depending on how many records are being synced. During this time records that
                                                            are being edited will not be synced.
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Button
                                                                fullWidth
                                                                // Updated to async/await with error handling to display messages to user
                                                                onClick={async () => {
                                                                    this.setState({
                                                                        syncLoading: true,
                                                                        syncErrorMessage: null
                                                                    });

                                                                    try {
                                                                        const resp = await fetch("runsync/" + section.id, {
                                                                            method: "POST",
                                                                            headers: {
                                                                                "Content-Type": "application/json",
                                                                                Authorization: "Token " + authState.auth.user.auth_token,
                                                                                "X-CSRFToken": getCSRFToken()
                                                                            },
                                                                        });

                                                                        let payload = null;
                                                                        const contentType = resp.headers.get("content-type") || "";
                                                                        if (contentType.includes("application/json")) {
                                                                            payload = await resp.json();
                                                                        } else {
                                                                            const text = await resp.text();
                                                                            payload = { detail: text };
                                                                        }

                                                                        if (!resp.ok) {
                                                                            const msg =
                                                                                payload?.error ||
                                                                                payload?.detail ||
                                                                                payload?.message ||
                                                                                `Sync failed (HTTP ${resp.status})`;

                                                                            const authHint = (resp.status === 401 || resp.status === 403)
                                                                                ? " (auth/token issue — check your login/session token)"
                                                                                : "";
                                                                            this.setState({ syncErrorMessage: msg + authHint });
                                                                            return;
                                                                        }

                                                                        if (payload?.error) {
                                                                            this.setState({ syncErrorMessage: payload.error });
                                                                            return;
                                                                        }

                                                                    } catch (e) {
                                                                        this.setState({
                                                                            syncErrorMessage: `Sync request failed: ${e?.message || String(e)}`,
                                                                        });

                                                                    } finally {
                                                                        this.setState({ syncLoading: false });
                                                                    }
                                                                }}
                                                            >
                                                                Sync MS4Front features to ArcGIS Online
                                                            </Button>

                                                            {/* Display of error message for user */}
                                                            {this.state.syncErrorMessage && (
                                                                <Typography
                                                                    style={{
                                                                        marginTop: 8,
                                                                        color: "red",
                                                                        fontStyle: "italic",
                                                                    }}
                                                                >
                                                                    {this.state.syncErrorMessage}
                                                                </Typography>
                                                            )}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}



                                        {!section && (
                                            <>
                                                <Grid container style={{ marginTop: 16 }} spacing={2}>
                                                    <Grid item xs={6}>
                                                        <Button
                                                            fullWidth
                                                            disabled={true}
                                                        >
                                                            Download Feature Service JSON File
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Button
                                                            fullWidth
                                                            // Updated to async/await with error handling to display messages to user
                                                            disabled={true}
                                                        >
                                                            Sync MS4Front features to ArcGIS Online
                                                        </Button>

                                                    </Grid>
                                                </Grid>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Typography
                                                        style={{
                                                            marginTop: 8,
                                                            fontStyle: "italic",
                                                            color: "gray"
                                                        }}
                                                    >
                                                        Form needs to be configured first for download & sync to be available.
                                                    </Typography>
                                                </Box>
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </SectionBox>
                </Grid>
            </Grid>
        );
    }

    render() {
        const {
            classes,
            returnEditDialog,
            open,
            section,
            geoHitFlag,
            handleGeoColor,
            handleMasterContacts,
            handleGeoType,
            handleDisplayModule,
            handleAttachmentTypes,
            handleChart,
            handleAutoSection,
            handleAGOLQuestions,
            attachmentHitFlag,
            chartHitFlag,
            contactHitFlag,
            AGOLHitFlag,
            otherSections,
            autoSectionHitFlag,
            displayModuleHitFlag,
            returnDialog,
        } = this.props;
        const { repeatableChange } = this.state;
        const isEdit = !!section?.id;
        const title = isEdit ? `Edit Section - ${section.name.charAt(0).toUpperCase() + section.name.slice(1)}` : "Add New Section";
        const closeHandler = isEdit ? returnEditDialog : returnDialog;

        let sectionForm = {};
        if (isEdit && section) {
            sectionForm = { ...section };
            delete sectionForm._forms;
            delete sectionForm._groupings;
        }
        // One-time flags on open
        if (open) {
            if (sectionForm.has_geometry && geoHitFlag) {
                handleGeoColor(true);
                if (["Point", "MultiPoint"].includes(sectionForm.geometry_type)) {
                    handleGeoType(sectionForm.geometry_type);
                }
            }
            if (sectionForm.is_master_contact_form && contactHitFlag) handleMasterContacts(true);
            if (sectionForm.has_attachments && attachmentHitFlag) handleAttachmentTypes(true);
            if (sectionForm.agol_service && AGOLHitFlag) handleAGOLQuestions(true);
            if (sectionForm.autocreate_another_section_record && autoSectionHitFlag) handleAutoSection(true);
            if (sectionForm.display_module && displayModuleHitFlag) handleDisplayModule(true);
            if (sectionForm.is_time_series_chart && chartHitFlag) handleChart(true);
        }

        // ---------- Chart-related dropdown fields ----------
        let _fields = [];
        let _datefields = [];
        let _numberfields = [];

        // Utility to populate fields from a section
        const extractChartFields = (targetSection) => {
            targetSection._forms?.forEach((_f) => {
                _f.groups?.forEach((_g) => {
                    _g.fields?.forEach((fl) => {
                        // Used in field selector
                        _fields.push({ label: `${fl.name} (${targetSection.name})`, value: fl.id.toString() });

                        const t = String(fl.type || "").trim();

                        const isDate =
                            t === "Date" ||
                            t === "Date/Time" ||
                            t === "Datetime" ||
                            t === "Date Time";

                        const isNumber =
                            t === "Numeric" ||
                            t === "Calculated" ||
                            t === "Currency" ||
                            t === "Decimal" ||
                            t === "Integer" ||
                            t === "Number";

                        if (isDate) {
                            _datefields.push({ label: fl.name, value: fl.id.toString() });
                        } else if (isNumber) {
                            // _numberfields.push({ label: fl.name, value: fl.id.toString() });
                            _numberfields.push({ label: fl.name, value: fl.id });
                        }
                    });
                });
            });
        };

        const chartSectionId = this?.state?.chart_section || section?.chart_section;
        if (chartSectionId) {
            otherSections
                .filter((s) => s?.id?.toString() === chartSectionId)
                .forEach(extractChartFields);
        }
        //  populate _fields for edit 
        if (isEdit && open && section?._forms) {
            otherSections.forEach(extractChartFields);
        }
        // ---------- Default values for create mode ----------
        if (!isEdit) {
            sectionForm = {
                repeatable_subform: true,
                append_fields: true,
                tableview_rowsperpage: 25,
                repeatable_rowsperpage: 10,
                geo_color: "#e53935",


                chart_line_color: "#000000",
                chart_point_color: "#4070C9",
                chart_line_width: 1,
                chart_point_size: 2,
                chart_line_color2: "#000000",
                chart_point_color2: "#FF5C00",
                chart_line_width2: 1,
                chart_point_size2: 2,


                ...(otherSections.length === 0 ? { parent: true } : {}),
                ...sectionForm, // Merge existing section properties
            };
        } else {
            sectionForm = {
                ...section, // Use existing section properties for edit mode
            };
        }

        if (Array.isArray(sectionForm.chart_plot_fields)) {
            sectionForm.chart_plot_fields = sectionForm.chart_plot_fields
                .filter(Boolean)
                .join(",");
        }

        const defaultValues = sectionForm;

        return (
            <Dialog
                open={open}
                // classes={{ paper: classes.minWidth }}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    style: {
                        resize: "both",
                        overflow: "hidden",
                        width: 900,
                        maxWidth: "95vw",
                        height: "757px",
                        minHeight: "757px",
                        maxHeight: "90vh",
                        minWidth: 800,
                    },
                }}
            >
                <Toolbar
                    style={{
                        backgroundColor: "#d3d3d3",
                    }}
                >
                    <Typography
                        variant="h5"
                        className={classes.flex}
                    >
                        {title}
                    </Typography>
                    <IconButton onClick={closeHandler}>
                        <Close />
                    </IconButton>
                </Toolbar>

                <DialogContent
                    classes={{ root: classes.dialogContent }}
                >
                    <DialogContentText
                        classes={{ root: classes.dialogContentText }}
                    >
                        <Formm
                            getApi={(el) => (this.formApi = el)}
                            dontValidateOnMount="true"
                            validateOnSubmit="true"
                            defaultValues={defaultValues}
                            validateError={this.errorValidator}
                            onSubmit={this.handleSubmit}
                        >
                            {(formApi) => {

                                const sectionForm = formApi.values;
                                const isTimeSeries = !!sectionForm.is_time_series_chart;
                                const tabValue = isTimeSeries ? 0 : this.state.activeTab;
                                const errors = formApi.errors || {};
                                const isMasterContacts = !!sectionForm.is_master_contact_form;


                                // Which fields to which tab
                                const basicsFields = [
                                    "name",
                                    "attachment_types",
                                    "parent",
                                    "has_attachments",
                                    "iframe_url",
                                    "append_to_prior_records",
                                    "single_record",
                                    "tableview_rowsperpage",
                                    "repeatable_rowsperpage",
                                    "autocreate_another_section_record",
                                    "autocreate_section_name",
                                    "use_master_contacts",
                                    "show_confirmation",
                                    "is_time_series_chart",
                                    "chart_section",
                                    "time_series_field",
                                    "chart_plot_fields",
                                ];

                                const recordBehaviorFields = [
                                    "chart_type",
                                    "chart_line_width",
                                    "chart_point_size",
                                    "chart_secondary_type",
                                    "chart_secondary_line_width",
                                    "chart_secondary_point_size",
                                ];

                                const mapFields = [
                                    "has_geometry",
                                    "geometry_type",
                                    "geo_color",
                                    "form_or_map",
                                    "display_list",
                                    "display_module",
                                    "display_module_page",
                                    "on_by_default",
                                    "show_label_on_map",
                                    "point_symbology",
                                    "point_size",
                                ];

                                const mobileFields = [
                                    "is_contact_form",
                                    "agol_service",
                                    "agol_username",
                                    "agol_password",
                                    "agol_referer",
                                    "token_url",
                                ];

                                const tabHasErrors = (fields) =>
                                    fields.some((f) => !!errors[f]);

                                const basicsHasError = tabHasErrors(basicsFields);
                                const recordBehaviorHasError = tabHasErrors(recordBehaviorFields);
                                const mapHasError = tabHasErrors(mapFields);
                                const mobileHasError = tabHasErrors(mobileFields);

                                const renderTabLabel = (text, hasError) => (
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                    >
                                        {text}
                                        {hasError && (
                                            <ErrorOutlineIcon
                                                fontSize="small"
                                                style={{ marginLeft: 4, color: "#d32f2f" }}
                                            />
                                        )}
                                    </span>
                                );

                                return (
                                    <form
                                        id="sectionForm"
                                        onSubmit={formApi.submitForm}

                                    >
                                        <StickyTabs>
                                            <Tabs
                                                value={tabValue}
                                                onChange={(e, value) => this.setState({ activeTab: value })}
                                                variant="fullWidth"
                                                className={classes.stickyTabStyles}
                                                classes={{ indicator: classes.tabsIndicator }}
                                            >
                                                <Tab
                                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                    icon={<ListIcon />}
                                                    label={renderTabLabel("Basics", basicsHasError)}
                                                />
                                                <Tab
                                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                    icon={isTimeSeries ? <BlockIcon /> : <TimelineIcon />}
                                                    label={renderTabLabel("Record Behavior", recordBehaviorHasError)}
                                                    disabled={isTimeSeries}
                                                />
                                                <Tab
                                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                    icon={isTimeSeries || isMasterContacts ? <BlockIcon /> : <MapIcon />}
                                                    label={renderTabLabel("Map & Legend", mapHasError)}
                                                    disabled={isTimeSeries || isMasterContacts}
                                                />
                                                <Tab
                                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                    icon={isTimeSeries || isMasterContacts ? <BlockIcon /> : <PhoneIphoneIcon />}
                                                    label={renderTabLabel("ArcGIS/Mobile", mobileHasError)}
                                                    disabled={isTimeSeries || isMasterContacts}
                                                />
                                            </Tabs>
                                        </StickyTabs>
                                        {tabValue === 0 && (
                                            <div className={classes.tabPanel}>
                                                {this.renderBasics(formApi, sectionForm)}
                                                <br />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    fullWidth
                                                >
                                                    Save
                                                </Button>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        )}
                                        {!isTimeSeries && tabValue === 1 && (
                                            <div className={classes.tabPanel}>
                                                {this.renderRecordBehavior(formApi, sectionForm)}
                                                <br />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    fullWidth
                                                >
                                                    Save
                                                </Button>
                                            </div>
                                        )}
                                        {!isTimeSeries && tabValue === 2 && (
                                            <div className={classes.tabPanel}>
                                                {this.renderMapSettings(formApi, sectionForm)}
                                                <br />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    fullWidth
                                                >
                                                    Save
                                                </Button>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        )}
                                        {!isTimeSeries && tabValue === 3 && (
                                            <div className={classes.tabPanel}>
                                                {this.renderMobileSettings(formApi, sectionForm)}
                                                <br />
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    fullWidth
                                                >
                                                    Save
                                                </Button>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        )}
                                    </form>
                                );
                            }}
                        </Formm>
                        {
                            isEdit && (
                                <WarningDialog
                                    confirmAction={() => this.setState({ repeatableChange: false })}
                                    cancelAction={() => this.setState({ repeatableChange: !repeatableChange })}
                                    open={repeatableChange}
                                    confirmText="Ok"
                                    title={`Warning`}
                                    contactLoading={false}
                                    noActions={false}
                                    noDeleteButtons={true}
                                    text="Are you sure you wish to change the creation of 'Repeatable' recordsections? Note: prior data that was saved as 'multiple' repeatable recordsections per primary record will not be seen unless this switch is reverted."
                                />
                            )
                        }
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

// The root component of the page
// http://localhost:3000/#/page/49
class PageDetail extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            newDialogOpen: false,
        };
        this.returnDialog = this.returnDialog.bind(this);
        this.openDialog = this.openDialog.bind(this);
    }
    returnDialog() {
        this.setState({ newDialogOpen: false });
    }
    openDialog() {
        this.setState({ newDialogOpen: true });
    }
    // When the save button is pressed update the name/icon of the page
    // This is the form on top of the page
    updatePage(values) {
        const { id } = this.props.page;
        const { ormPageUpdate } = this.props;

        ormPageUpdate({
            id: id,
            ...values,
        });

        this.props.history.push("/config/page");
    }
    // componentDidMount() {
    //     const { ormFieldReload } = this.props;
    //     ormFieldReload();
    // }
    render() {
        const {
            classes,
            page,
            pages,
            sections,
            forms,
            ormSectionCreate,
            ormSectionDelete,
            ormSectionUpdate,
            ormFormCreate,
            ormFormUpdate,
            history,
            authState,
            ormSectionMapGroupingCreate,
            ormSectionMapGroupingUpdate,
            ormSectionMapGroupingDelete,
            ormSectionLoadDetailChild,
            ormGroupingValueCreate,
            ormGroupingValueUpdate,
            ormGroupingValueDelete,
            mapGroups,
            groupValues,
        } = this.props;
        const { newDialogOpen } = this.state;
        return (
            <AppContainer authenticated>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h5">Module Configuration: {page.name}</Typography>
                        <Typography className={classes.italics}>Use this module to create, edit, or delete forms used on {page.name}.</Typography>
                    </Grid>
                    <Grid item style={{ textAlign: "end", marginTop: 10 }} xs={12} md={4}>
                        <Tooltip
                            title={
                                <div>
                                    Export module, sections and form configurations.
                                    <br />
                                    This does not export module records.
                                </div>
                            }>
                            <Button
                                variant="raised"
                                type="button"
                                size="medium"
                                onClick={() => window.open("/excel/exportpage/" + page.id)}>
                                Export Module to Spreadsheet&nbsp;&nbsp;&nbsp;
                                <CloudDownload />
                            </Button>
                        </Tooltip>
                    </Grid>
                    {/* <Grid container>
                        <Grid xs={7}>
                            <BreadCrumbs allPageConfig={"/config/page"} sectionConfig={`/page/${page.id}/config`} />
                        </Grid>
                    </Grid> */}
                    <Grid item xs={12} sm={10} md={8} lg={6} xl={4}>
                        <Formm
                            getApi={(el) => (this.formApi = el)}
                            dontValidateOnMount="true"
                            validateOnSubmit="true"
                            validateError={this.errorValidator}
                            defaultValues={page}
                            onSubmit={(values) => this.updatePage(values)}>
                            {(formApi) => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                field="name"
                                                label="Name-Enter the module name that will appear on the app and reports"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Select
                                                field="icon"
                                                label="Icon-Choose an icon that will appear on the app and reports"
                                                options={MAKE_OPTIONS_ICON(ICON_LIST)}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <ColorPicker field="icon_color" label="Icon Color" />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField field="iframe_url" label="(Optional) Configure module as an iframe - enter URL" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button type="submit" variant="contained" color="primary">
                                                Save
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formm>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5">Section Configuration</Typography>
                        <Typography className={classes.italics}>
                            Define the details of what types of data a Module stores. For each Section you add, identify the data fields and choose
                            from several different options.
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        {/* <Button onClick={this.openDialog} fullWidth className={classes.gutterBottom} variant="contained" color="primary">
                            <AddCircleOutlineIcon />
                            &nbsp;&nbsp;&nbsp;Add New Section
                        </Button> */}
                        <SectionTable
                            page={page.id}
                            sections={sections}
                            forms={forms}
                            pages={pages}
                            returnDialog={this.returnDialog}
                            newDialogOpen={newDialogOpen}
                            classes={classes}
                            ormSectionCreate={ormSectionCreate}
                            ormSectionDelete={ormSectionDelete}
                            ormSectionUpdate={ormSectionUpdate}
                            ormSectionMapGroupingCreate={ormSectionMapGroupingCreate}
                            ormSectionMapGroupingUpdate={ormSectionMapGroupingUpdate}
                            ormSectionMapGroupingDelete={ormSectionMapGroupingDelete}
                            ormSectionLoadDetailChild={ormSectionLoadDetailChild}
                            ormGroupingValueCreate={ormGroupingValueCreate}
                            ormGroupingValueUpdate={ormGroupingValueUpdate}
                            ormGroupingValueDelete={ormGroupingValueDelete}
                            ormFormCreate={ormFormCreate}
                            ormFormUpdate={ormFormUpdate}
                            history={history}
                            mapGroups={mapGroups}
                            groupValues={groupValues}
                            authState={authState}
                        />
                    </Grid>
                </Grid>
            </AppContainer>
        );
    }
}
PageDetail.displayName = "PageDetail";

// This connects the redux-orm functions getPage, getSections,  allows the PageDetail to have the props "page", "sections", and "allForms"
// The second part loads all orm actions into the PageConfig props for both Page and Section: ormPageCreate, ormSectionCreate, orPageUpdate, etc.
PageDetail = connect(
    (state, ownProps) => ({
        page: getPage(state, ownProps),
        pages: allPages(state, ownProps),
        sections: getSections(state, ownProps),
        forms: allForms(state, ownProps),
        mapGroups: getGroupings(state, ownProps),
        groupValues: getValueGroupings(state, ownProps),
        authState: state,
    }),
    {
        ...Page.actions,
        ...Section.actions,
        ...Form.actions,
        ...Field.actions,
        ...GroupingValue.actions,
        ...SectionMapGrouping.actions,
    }
)(PageDetail);

export default withStyles(styles)(withRouter(PageDetail));